import React, { Component } from 'react';
import axios from "axios";
import {appConfig} from "./../../tools/AppConfig";
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import Button from 'react-validation/build/button';
import Waiting from './../waiting';
import './../../custom.css';
import './../../pages/invoice.css';
import validator from 'validator';
const required = (value) => {
  if (!value.toString().trim().length) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> This field is required.</div>;
  }
};
const PhoneNumber = (value) => {
    if(!validator.isNumeric(value) || value.toString().trim().length > 14 || value.toString().trim().length < 8 ){
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter valid Phone number.</div>;
    }
};

class wallet extends Component {
      constructor(props) {
        super(props);
        this.state = {
            waiting: false,
            userData: props.userData,
            deliveryNeed: props.deliveryNeed,
            deliveryData: props.deliveryData,
            phone: '',
        };
        this.getFirstName = this.getFirstName.bind(this);
        this.getLastName = this.getLastName.bind(this);
        this.handelPhoneChange = this.handelPhoneChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
      }

    getFirstName(fullName) {
    var namesArr = fullName.split(" ");
    return namesArr[0]
    }
    getLastName(fullName) {
    var namesArr = fullName.split(" ");
    return namesArr[namesArr.length - 1];
    }
  handelPhoneChange(e) {
    this.setState({phone: e.target.value});
  }
  handleSubmit(event) {
    //--- strat waiting
    this.setState({waiting: true});
    let url;
    if(this.props.sourcePage ==='invoice'){
        url = appConfig.getServerUrl() + '/invoice2/'+ this.state.userData.token;
    }else if(this.props.sourcePage ==='product'){
        url = appConfig.getServerUrl() + '/product2/'+ this.state.userData.token;
    }
    let paymentDict;
    if(this.props.sourcePage ==='invoice'){
        paymentDict = {
            "source": {
                "identifier" : this.state.phone,
                "subtype": "WALLET"
            }, "shipping_data": {
                'apartment': "",
                'email': this.state.userData.order_email,
                'floor': "",
                'first_name': this.getFirstName(this.state.userData.order_full_name),
                'street': "",
                'building': "",
                'phone_number': this.state.userData.order_phone,
                'postal_code': "",
                'city': "",
                'country': "",
                'last_name': this.getLastName(this.state.userData.order_full_name),
                'state': "",
                'extra_description': ''
            },
            "token": this.state.userData.token,
            "integration_id": this.state.userData.integration_ids.UIG
        };
        if(this.state.deliveryNeed){
            paymentDict.shipping_data.country = this.state.deliveryData.country;
            paymentDict.shipping_data.state = this.state.deliveryData.state;
            paymentDict.shipping_data.city = this.state.deliveryData.city;
            paymentDict.shipping_data.building = this.state.deliveryData.building;
            paymentDict.shipping_data.street = this.state.deliveryData.street;
            paymentDict.shipping_data.floor = this.state.deliveryData.floor;
            paymentDict.shipping_data.apartment = this.state.deliveryData.apartment;
            paymentDict.shipping_data.postal_code = this.state.deliveryData.postal_code;
            paymentDict.shipping_data.extra_description = this.state.deliveryData.notes;
        }
    }else if(this.props.sourcePage ==='product'){
        paymentDict = {
            "order_data": {
                "delivery_needed": this.state.deliveryNeed,
                "amount_cents": this.state.userData.amount * this.props.quantity * 100,
                "currency": this.state.userData.currency,
                "shipping_data": {
                    "first_name": this.getFirstName(this.state.deliveryData.name),
                    "last_name": this.getLastName(this.state.deliveryData.name),
                    "phone_number": this.state.deliveryData.phone,
                    "email": this.state.deliveryData.email,
                    "street": 'NA',
                    "city": 'NA',
                    "country": 'NA',
                    "postal_code": 'NA',
                    "state": "NA"
                },
                "items": [{
                    "name": this.state.userData.product.product_name,
                    "amount_cents": this.state.userData.amount * 100,
                    "quantity": this.props.quantity,
                }]
            },
            "source": {
                "identifier" : this.state.phone,
                "subtype": "WALLET"
            },
            "token": this.state.userData.token,
            "integration_id": this.state.userData.integrations.UIG
        };
        if(this.state.deliveryNeed){
            paymentDict.order_data.shipping_data.country = this.state.deliveryData.country;
            paymentDict.order_data.shipping_data.state = this.state.deliveryData.state;
            paymentDict.order_data.shipping_data.city = this.state.deliveryData.city;
            paymentDict.order_data.shipping_data.building = this.state.deliveryData.building;
            paymentDict.order_data.shipping_data.street = this.state.deliveryData.street;
            paymentDict.order_data.shipping_data.floor = this.state.deliveryData.floor;
            paymentDict.order_data.shipping_data.apartment = this.state.deliveryData.apartment;
            paymentDict.order_data.shipping_data.postal_code = this.state.deliveryData.postal_code;
            paymentDict.order_data.shipping_data.extra_description = this.state.deliveryData.notes;
        }
    }
    let jsonPaymentDict = JSON.stringify(paymentDict);
    let config = {
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    axios.post(url, jsonPaymentDict, config)
    .then((resp) => {
        if(resp.data.success === true){
            if (resp.data.url) {
                window.location.href = resp.data.url;
            }else {
                //succes without url and not delivery
                this.props.setReqComplete({head: 'Transaction successful', body:'Thank you for using the online payment service.'});
            }
        }else{
            //succes = false
            this.props.setReqComplete({head: 'Transaction declined', body:'Please try again later. If this problem persists, please contact your service provider.'});
        }
    })
    .catch((err) => {
        //--- end waiting
        this.setState({waiting: false});
        if(err.response.status === 404){
            alert('Please check your internet connection and try again.');
        }
    });
    event.preventDefault();
  }

  render() {
    return (
        <div className="walletNew">
                {this.state.waiting?
                    <Waiting height="107px" />
                :
                    <Form onSubmit={this.handleSubmit}>
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                <div className="newInput">
                                        <Input type="number"
                                         pattern="[0-9]*" 
                                         name="c_pan_U" placeholder="Phone"
                                        value={this.state.phone}
                                        onChange={this.handelPhoneChange}
                                        validations={[required, PhoneNumber]} 
                                        />
                                </div>
                            </div>
                        </div>
                        <div className='text-center'>
                            <Button className="confirmBtnNew">CONFIRM</Button>
                        </div>
                    </Form> 
                }               
        </div>
    );
  }
}

export default wallet;
